import { render, staticRenderFns } from "./FormBuilderLayoutSetting.vue?vue&type=template&id=549beb9d&scoped=true"
import script from "./FormBuilderLayoutSetting.vue?vue&type=script&lang=js"
export * from "./FormBuilderLayoutSetting.vue?vue&type=script&lang=js"
import style0 from "./FormBuilderLayoutSetting.vue?vue&type=style&index=0&id=549beb9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549beb9d",
  null
  
)

export default component.exports